import { Theme } from '@material-ui/core/styles';
import { TabsClassKey } from '@material-ui/core/Tabs';

const MuiTabs = (theme: Theme): Partial<Record<TabsClassKey, unknown>> => ({
    root: {
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
        flexGrow: 1,
    },
    indicator: {
        height: 4,
        borderRadius: 34,
    },
});

export default MuiTabs;
